<template>
  <div>
      <i class="el-icon-printer" @click="printer(value)" title="暂存打印" style="margin-left: 20px;font-size: 15px"></i>
  </div>
</template>
<script>
  export default {
    data: function () {
      return {
        value: null,
        number: null,
      }
    },
    mounted() {

    },
    methods: {
      printer(value) {
        console.log("value",value)
        this.$emit('clickModule',value)
      }
    }
  }
</script>
<style scoped>
  .stepSuc :hover {
    cursor: pointer;
  }
</style>
